import '@mdi/font/css/materialdesignicons.css';
import '@geta/kolumbus-assets';
import 'vuetify/styles';
import '@geta/kolumbus-frontend/styles';
import '@/styles/main.scss';
import 'reflect-metadata';
import { createApp } from 'vue';
import { createVuetify, Blueprint } from 'vuetify';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import App from './App.vue';
import pinia from './store';
import router from './router';
import i18n from './i18n';
import v1 from '@geta/kolumbus-frontend/blueprints/v1';
import { createContainer } from '@/plugins/inversify';
import { useI18n } from 'vue-i18n';
import { useMainStore } from '@/features/common/stores';
import { setupApp } from '@geta/kolumbus-frontend/features/common';

const app = createApp(App)
    .use(createContainer())
    .use(router)
    .use(pinia)
    .use(i18n)
    .use(
        createVuetify({
            blueprint: v1 as Blueprint,
            locale: {
                adapter: createVueI18nAdapter({ i18n, useI18n })
            },
            theme: {
                themes: {
                    light: {
                        colors: {
                            'primary-light': '#00AA50',
                            'secondary-light': '#646464',
                            'dark-grey': '#424E57',
                            'secondary-dark': '#1A1C21',
                            warning: '#D27E00',
                            'warning-10': '#f9f3e7',
                            error: '#D7251F',
                            'error-10': '#f8ebe9',
                            'bg-focused': '#F2FBF6',
                            'bg-primary': '#F7F7F7',
                            'bg-old-card': '#D5FFD2',
                            'bg-card': '#f8f8f8',
                            'border-primary': '#E3E3E3'
                        }
                    }
                }
            }
        })
    );

useMainStore()
    .loadConfig()
    .then(config => {
        if (!config) {
            throw new Error('Failed to load config');
        }

        // setup app
        app.use(setupApp(config));

        // mount app
        app.mount('#app');
    });
